import { createRouter, createWebHashHistory } from "vue-router";

// 引入组件并且设置路由
const index = () => import("@/views/index.vue");
const products = () => import("@/views/products.vue");
const aboutUs = () => import("@/views/aboutUs.vue");
const cooperative = () => import("@/views/cooperative/index.vue");
const contactUs = () => import("@/views/contactUs.vue");
const login = () => import("@/views/login.vue");
const register = () => import("@/views/register.vue");
const downloadFile = () => import("@/views/downloadFile.vue");
const userDetail = () => import("@/views/userDetail.vue");
const userDetailUpdate = () => import("@/views/userDetailUpdate.vue");
const detailspress = () => import("@/views/cooperative/detailspress.vue");
const detailspress2 = () => import("@/views/cooperative/detailspress2.vue");
const detailspress3 = () => import("@/views/cooperative/detailspress3.vue");
const detailspress4 = () => import("@/views/cooperative/detailspress4.vue");
// 创建路由
const router = createRouter({
  history: createWebHashHistory(), //createWebHistory 路由没有#号 createWebHashHistory 
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        title:
          "世通在线 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/products",
      name: "products",
      component: products,
      meta: {
        title:
          "产品 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: aboutUs,
      meta: {
        title:
          "关于世通 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/cooperative",
      name: "cooperative",
      component: cooperative,
      meta: {
        title:
          "关于世通 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/contactUs",
      name: "contactUs",
      component: contactUs,
      meta: {
        title:
          "联系我们 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        title:
          "登录账号 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        title:
          "注册账号 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/downloadFile",
      name: "downloadFile",
      component: downloadFile,
      meta: {
        title:
          "世通在线客户端下载 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/userDetail",
      name: "userDetail",
      component: userDetail,
      meta: {
        title:
          "信息中心 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/userDetailUpdate",
      name: "userDetailUpdate",
      component: userDetailUpdate,
      meta: {
        title:
          "修改信息 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/detailspress",
      name: "detailspress",
      component: detailspress,
      meta: {
        title:
          "新闻详情 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    {
      path: "/detailspress2",
      name: "detailspress2",
      component: detailspress2,
      meta: {
        title:
          "新闻详情 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    }, {
      path: "/detailspress3",
      name: "detailspress3",
      component: detailspress3,
      meta: {
        title:
          "新闻详情 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    }, {
      path: "/detailspress4",
      name: "detailspress4",
      component: detailspress4,
      meta: {
        title:
          "新闻详情 - 世通，世通在线，世通软件，ERP，报价系统，询价系统，进销存，机加工，模具",
      },
    },
    { path: "/:path(.*)", redirect: "/" },
  ],
  // scrollBehavior(to, from, savedPosition) {
  //   // 如果有 savedPosition，则滚动到保存的位置
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     // 否则滚动到页面顶部
  //     return { top: 0 };
  //   }
  // },
});

// 给每个路由的 title 动态赋值
router.beforeEach((to, from, next) => {
  // console.log(to)
  window.document.title = to.meta.title;
  next();
});

export default router;
